import { Label_Read, Label_Read_Nested } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class BasicLabel {
  constructor(
    private _id: string,
    private _name: string,
    private _color: string,
    private _discarded_at: Dayjs | null = null,
  ) {
    this._id = _id;
    this._name = _name;
    this._color = _color;
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get color() {
    return this._color;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  public static parse(proto: Label_Read_Nested) {
    return new BasicLabel(
      proto.id,
      proto.name,
      proto.color,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
}

export class Label {
  constructor(
    private _id: string,
    private _name: string,
    private _color: string,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _discarded_at: Dayjs | null = null,
  ) {
    this._id = _id;
    this._name = _name;
    this._color = _color;
    this._created_at = _created_at;
    this._updated_at = _updated_at;
  }

  public static parse(proto: Label_Read) {
    return new Label(
      proto.id,
      proto.name,
      proto.color,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get color() {
    return this._color;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public get discardedAt() {
    return this._discarded_at;
  }
}
